// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./tarot/types";
import { majorArcanaTarotCards } from "./tarot/major";
import { wandsTarotCards } from "./tarot/wands";
import { cupsTarotCards } from "./tarot/cups";
import { swordsTarotCards } from "./tarot/swords";
import { pentaclesTarotCards } from "./tarot/pentacles";

export type { TarotMeaning, TarotReferenceCard } from "./tarot/types";

export const tarotCards: readonly TarotReferenceCard[] = [
  ...majorArcanaTarotCards,
  ...wandsTarotCards,
  ...cupsTarotCards,
  ...swordsTarotCards,
  ...pentaclesTarotCards,
];

export const tarotCardMap: Readonly<Record<number, TarotReferenceCard>> = Object.fromEntries(
  tarotCards.map((card) => [card.id, card])
);
